import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** SPA 遷移時にウィンドウスクロールを先頭へ戻す（iPad Safari のキーボード連動スクロール残留対策など） */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);
  return null;
}
